import { useHeaderData } from '../../../hooks/use-header-data';
export var useMetaMenuLinks = function useMetaMenuLinks() {
  var headerData = useHeaderData();

  if (!headerData) {
    return {
      userLinks: []
    };
  }

  var metaMenuLinks = {
    contactSalesLink: headerData === null || headerData === void 0 ? void 0 : headerData.contactSalesLink,
    userLinks: [{
      variant: 'secondary',
      link: headerData.loginLink
    }, {
      variant: 'primary',
      link: headerData.signupButton
    }]
  };

  if (headerData !== null && headerData !== void 0 && headerData.isLoggedIn) {
    metaMenuLinks.userLinks = [{
      variant: 'primary',
      link: headerData.dashboardButton
    }];
  }

  return metaMenuLinks;
};